/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TourEditMarkerDeleteDialogDeleteMarkerMutationVariables = {
    markerId: string;
};
export type TourEditMarkerDeleteDialogDeleteMarkerMutationResponse = {
    readonly markerDelete: {
        readonly clientMutationId: string | null;
    };
};
export type TourEditMarkerDeleteDialogDeleteMarkerMutation = {
    readonly response: TourEditMarkerDeleteDialogDeleteMarkerMutationResponse;
    readonly variables: TourEditMarkerDeleteDialogDeleteMarkerMutationVariables;
};



/*
mutation TourEditMarkerDeleteDialogDeleteMarkerMutation(
  $markerId: ID!
) {
  markerDelete(input: {markerId: $markerId}) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "markerId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "markerId",
            "variableName": "markerId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "MarkerDeletePayload",
    "kind": "LinkedField",
    "name": "markerDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TourEditMarkerDeleteDialogDeleteMarkerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TourEditMarkerDeleteDialogDeleteMarkerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9ff25bb0a4cd728b2d4df417c9b591de",
    "id": null,
    "metadata": {},
    "name": "TourEditMarkerDeleteDialogDeleteMarkerMutation",
    "operationKind": "mutation",
    "text": "mutation TourEditMarkerDeleteDialogDeleteMarkerMutation(\n  $markerId: ID!\n) {\n  markerDelete(input: {markerId: $markerId}) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '54f24dd208aaea0c12196cd325b8a00b';
export default node;
